import Gallant1 from '../../../Media/BSD/Tresor/Tersor Gallant.webp'
import Gallant2 from '../../../Media/BSD/Tresor/Tersor Gallant.webp'





const Gallantimages =[
Gallant1,Gallant2
]

export default Gallantimages;